import { z } from 'zod';

import { DocumentId } from '../BrandedIds';
import { BorrowerAccessSaveInput } from '../loan/DocumentAccess';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateDocumentBorrowerAccessEvent = BaseLoanEvent.extend({
  type: z.literal('updateDocumentBorrowerAccess'),
  documentId: DocumentId,
  documentTitle: z.string(),
  originalBorrowerAccess: BorrowerAccessSaveInput,
  newBorrowerAccess: BorrowerAccessSaveInput,
});

export type UpdateDocumentBorrowerAccessEvent = z.infer<typeof UpdateDocumentBorrowerAccessEvent>;
